/* generated by gen-client-metadata.mjs — do not edit */
'use strict';
module.exports = {
  "client_id": "https://follower.psingletary.com/client-metadata.json",
  "client_name": "Follower",
  "client_uri": "https://follower.psingletary.com",
  "redirect_uris": [
    "https://follower.psingletary.com/login/callback"
  ],
  "scope": "atproto repo:app.askeverything.graph.follow?action=create&action=delete repo:app.bsky.graph.follow?action=create&action=delete repo:app.certified.graph.follow?action=create&action=delete repo:app.rocksky.graph.follow?action=create&action=delete repo:app.skyreader.social.follow?action=create&action=delete repo:app.standard-reader.graph.follow?action=create&action=delete repo:com.getorbyt.graph.follow?action=create&action=delete repo:id.sifa.graph.follow?action=create&action=delete repo:io.kich.graph.follow?action=create&action=delete repo:is.currents.graph.follow?action=create&action=delete repo:network.cosmik.follow?action=create&action=delete repo:pics.2bit.graph.follow?action=create&action=delete repo:place.pollen.graph.follow?action=create&action=delete repo:sh.tangled.graph.follow?action=create&action=delete repo:so.sprk.graph.follow?action=create&action=delete repo:social.grain.graph.follow?action=create&action=delete repo:space.opendeck.follow?action=create&action=delete repo:space.priiv.follow?action=create&action=delete",
  "grant_types": [
    "authorization_code",
    "refresh_token"
  ],
  "response_types": [
    "code"
  ],
  "token_endpoint_auth_method": "none",
  "application_type": "web",
  "dpop_bound_access_tokens": true
};
